import { current } from '@reduxjs/toolkit';
import { PERMISSIONS } from './permissions';
import { ROUTE_URLS } from './route_urls';

const checkPermissions = (requiredPermissions, userPermissions) => {
    if (!requiredPermissions) {
        return true;
    }
    let response = false;
    requiredPermissions.forEach((permission) => {
        if (userPermissions?.indexOf(permission) !== -1) {
            response = true;
        }
    });
    return response;
};

export const WEBSITE_NAV_V2 = (currentUser) => {
    return [
        {
            url: ROUTE_URLS.dashboard,
            icon: 'home',
            enabled: true,
        },
        {
            url: ROUTE_URLS.reports,
            icon: 'pie',
            enabled: checkPermissions(PERMISSIONS.reports, currentUser?.permissions),
        },
        {
            url: ROUTE_URLS.runners,
            enabled:
                checkPermissions(PERMISSIONS.leads, currentUser?.permissions) &&
                (currentUser?.company?.brand?.rego_enabled ||
                    currentUser?.company?.brand?.crm?.includes('flow')),
            label: 'Leads',
        },
        {
            label: 'Borrowers',
            enabled:
                checkPermissions(PERMISSIONS.leads, currentUser?.permissions) &&
                (!currentUser?.company?.brand?.crm ||
                    currentUser?.company?.brand?.crm?.includes('v1')),
            children: [
                {
                    url: ROUTE_URLS.master,
                    enabled: checkPermissions(PERMISSIONS.leads_all, currentUser?.permissions),
                    label: 'All Borrowers',
                },
                {
                    url: ROUTE_URLS.kyc_pending,
                    label: 'KYC Pending',
                    enabled: checkPermissions(
                        PERMISSIONS.leads_kyc_pending,
                        currentUser?.permissions
                    ),
                },
                {
                    url: ROUTE_URLS.bre_pending,
                    label: 'BRE Pending',
                    enabled: checkPermissions(
                        PERMISSIONS.leads_bre_pending,
                        currentUser?.permissions
                    ),
                },
            ],
        },
        {
            label: 'Credit',
            enabled:
                checkPermissions(PERMISSIONS.credit, currentUser?.permissions) &&
                (!currentUser?.company?.brand?.crm ||
                    currentUser?.company?.brand?.crm?.includes('v1')),
            children: [
                {
                    url: ROUTE_URLS.accounts_pending_underwriting,
                    label: 'Pending Underwriting',
                    enabled: checkPermissions(
                        PERMISSIONS.credit_pending_underwriting,
                        currentUser?.permissions
                    ),
                },
                {
                    url: '#',
                    label: 'Offer Acceptance (Coming Soon)',
                    enabled: true,
                    disabled: true,
                },
            ],
        },
        {
            label: 'Ops',
            enabled:
                checkPermissions(PERMISSIONS.ops, currentUser?.permissions) &&
                (!currentUser?.company?.brand?.crm ||
                    currentUser?.company?.brand?.crm?.includes('v1')),
            children: [
                {
                    url: ROUTE_URLS.accounts_signing,
                    label: 'Signing',
                    enabled: checkPermissions(PERMISSIONS.ops_signing, currentUser?.permissions),
                },
                {
                    url: ROUTE_URLS.accounts_mandates,

                    label: 'Mandates',
                    enabled: checkPermissions(PERMISSIONS.ops_mandates, currentUser?.permissions),
                },
                {
                    url: ROUTE_URLS.accounts_pdcs,
                    label: 'PDC',
                    enabled: checkPermissions(PERMISSIONS.ops_pdcs, currentUser?.permissions),
                },
                {
                    url: ROUTE_URLS.accounts_fee,
                    label: 'Fee',
                    enabled: checkPermissions(PERMISSIONS.ops_fee, currentUser?.permissions),
                },
                {
                    url: ROUTE_URLS.accounts_insurance,
                    label: 'Insurance',
                    enabled: checkPermissions(PERMISSIONS.ops_insurance, currentUser?.permissions),
                },
                {
                    url: ROUTE_URLS.accounts_assessments,
                    label: 'Assessments',
                    enabled: checkPermissions(PERMISSIONS.ops_assessment, currentUser?.permissions),
                },
                {
                    url: ROUTE_URLS.activation,
                    label: 'Pending Activation',
                    enabled: checkPermissions(PERMISSIONS.ops_activation, currentUser?.permissions),
                },
                {
                    url: '/disbursal/topups',
                    label: 'Drawdowns',
                    enabled: checkPermissions(PERMISSIONS.drawdowns, currentUser?.permissions),
                },
            ],
        },
        {
            label: 'Accounts',
            enabled:
                checkPermissions(PERMISSIONS.accounts, currentUser?.permissions) &&
                (!currentUser?.company?.brand?.crm ||
                    !currentUser?.company?.brand?.crm?.includes('flow')),
            children: [
                {
                    url: ROUTE_URLS.payouts,
                    label: 'Payouts',
                    enabled: checkPermissions(
                        PERMISSIONS.accounts_payouts,
                        currentUser?.permissions
                    ),
                },
                {
                    url: ROUTE_URLS.payouts_batch,
                    label: 'Payout Batch',
                    enabled: checkPermissions(
                        PERMISSIONS.accounts_payouts,
                        currentUser?.permissions
                    ),
                },
                {
                    url: '/accounting/records',

                    label: 'Repayments',
                    enabled: checkPermissions(
                        PERMISSIONS.accounts_records,
                        currentUser?.permissions
                    ),
                },
                {
                    url: ROUTE_URLS.disbursal_cashback,
                    label: 'Excess Balance',
                    enabled: checkPermissions(
                        PERMISSIONS.accounts_payouts,
                        currentUser?.permissions
                    ),
                },
                {
                    url: ROUTE_URLS.demand_sheet,
                    label: 'Upcoming Dues',
                    enabled: currentUser.username === 'rajankur_amex',
                },
            ],
        },
        {
            label: 'Accounts',
            enabled:
                checkPermissions(PERMISSIONS.accounts, currentUser?.permissions) &&
                (currentUser?.company?.brand?.rego_enabled ||
                    currentUser?.company?.brand?.crm?.includes('flow')),
            children: [
                {
                    url: ROUTE_URLS.master,
                    enabled: checkPermissions(PERMISSIONS.leads, currentUser?.permissions),
                    label: 'All Accounts',
                },
                {
                    url: ROUTE_URLS.payouts,
                    label: 'Payouts',
                    enabled: checkPermissions(PERMISSIONS.payouts, currentUser?.permissions),
                },
                {
                    url: ROUTE_URLS.payouts_batch,
                    label: 'Payout Batch',
                    enabled: checkPermissions(
                        PERMISSIONS.accounts_payouts,
                        currentUser?.permissions
                    ),
                },
                {
                    url: '/accounting/records',
                    label: 'Repayments',
                    enabled: checkPermissions(
                        PERMISSIONS.accounts_records,
                        currentUser?.permissions
                    ),
                },
                {
                    url: ROUTE_URLS.disbursal_cashback,
                    label: 'Excess Balance',
                    enabled: checkPermissions(
                        PERMISSIONS.accounts_payouts,
                        currentUser?.permissions
                    ),
                },
            ],
        },
        {
            label: 'Banking',
            enabled:
                checkPermissions(PERMISSIONS.banking, currentUser?.permissions) &&
                (!currentUser?.company?.brand?.crm ||
                    currentUser?.company?.brand?.crm?.includes('v1')) &&
                currentUser?.type === 'lender',
            children: [
                {
                    url: '/lms/banking/statements',
                    label: 'Statements',
                    enabled: true,
                },
                {
                    url: '/lms/banking/transactions',
                    label: 'Transactions',
                    enabled: true,
                },
                {
                    url: '/lms/banking/suspense-balances',
                    label: 'Suspense Balances',
                    enabled: true,
                },
                {
                    url: '/lms/banking/unmatched-entries',
                    label: 'Unmatched Entries',
                    enabled: true,
                },
            ],
        },
        {
            label: 'Approvals',
            enabled: checkPermissions(PERMISSIONS.approvals, currentUser?.permissions),
            children: [
                {
                    url: ROUTE_URLS.kyc_approvals,
                    label: 'KYC Approval',
                    enabled:
                        checkPermissions(PERMISSIONS.approvals_kyc, currentUser?.permissions) &&
                        (!currentUser?.company?.brand?.crm ||
                            currentUser?.company?.brand?.crm?.includes('v1')),
                },
                {
                    url: ROUTE_URLS.bre_approvals,
                    label: 'BRE Approval',
                    enabled:
                        checkPermissions(PERMISSIONS.approvals_bre, currentUser?.permissions) &&
                        (!currentUser?.company?.brand?.crm ||
                            currentUser?.company?.brand?.crm?.includes('v1')),
                },
                {
                    url: ROUTE_URLS.credit_approvals,
                    label: 'Credit Approval',
                    enabled:
                        checkPermissions(PERMISSIONS.approvals_credit, currentUser?.permissions) &&
                        (!currentUser?.company?.brand?.crm ||
                            currentUser?.company?.brand?.crm?.includes('v1')),
                },
                {
                    url: ROUTE_URLS.activation_approvals,

                    label: 'Activation Approval',
                    enabled: checkPermissions(
                        PERMISSIONS.approvals_activation,
                        currentUser?.permissions
                    ),
                },
                {
                    url: ROUTE_URLS.topup_approvals,

                    label: 'Drawdown Approvals',
                    enabled: checkPermissions(
                        PERMISSIONS.approvals_drawdown,
                        currentUser?.permissions
                    ),
                },
                {
                    url: ROUTE_URLS.topup_anomaly_approvals,
                    label: 'Drawdown Anomaly Approvals',
                    enabled: checkPermissions(
                        PERMISSIONS.approvals_drawdown_anomaly,
                        currentUser?.permissions
                    ),
                },
                {
                    url: ROUTE_URLS.payout_approvals,

                    label: 'Payout Approvals',
                    enabled: checkPermissions(
                        PERMISSIONS.approvals_payouts,
                        currentUser?.permissions
                    ),
                },
                {
                    url: ROUTE_URLS.record_approvals,
                    label: 'Repayment Approvals',
                    enabled: checkPermissions(
                        PERMISSIONS.approvals_records,
                        currentUser?.permissions
                    ),
                },
            ],
        },
        {
            label: 'Admin',
            enabled: checkPermissions(PERMISSIONS.admin, currentUser?.permissions),
            children: [
                {
                    url: ROUTE_URLS.my_company,
                    label: 'My Company',
                    enabled:
                        currentUser?.company_id &&
                        checkPermissions(PERMISSIONS.admin_companies, currentUser?.permissions),
                },
                {
                    url: ROUTE_URLS.users,
                    label: 'Users',
                    enabled: checkPermissions(PERMISSIONS.admin_users, currentUser?.permissions),
                },
                {
                    url: ROUTE_URLS.user_roles,
                    label: 'User Roles',
                    enabled: checkPermissions(PERMISSIONS.admin_users, currentUser?.permissions),
                },
                {
                    url: ROUTE_URLS.user_permissions,
                    label: 'User Permissions',
                    enabled: !currentUser.company_id,
                },
                {
                    url: ROUTE_URLS.companies,
                    label: currentUser.company_id ? 'Partner Companies' : 'Companies',
                    enabled: checkPermissions(
                        PERMISSIONS.admin_companies,
                        currentUser?.permissions
                    ),
                },
                {
                    url: ROUTE_URLS.gl,
                    label: 'GL Accounts',
                    enabled:
                        checkPermissions(
                            PERMISSIONS.admin_ledger_config,
                            currentUser?.permissions
                        ) && currentUser?.type !== 'anchor',
                },
                {
                    url: ROUTE_URLS.gl_transactions,

                    label: 'GL Transactions',
                    enabled:
                        checkPermissions(
                            PERMISSIONS.admin_ledger_config,
                            currentUser?.permissions
                        ) && currentUser?.type !== 'anchor',
                },
                {
                    url: ROUTE_URLS.programs,
                    label: 'Programs',
                    enabled: checkPermissions(PERMISSIONS.admin_programs, currentUser?.permissions),
                },
                {
                    url: ROUTE_URLS.flows,
                    label: 'Flows',
                    enabled: checkPermissions(PERMISSIONS.admin_programs, currentUser?.permissions),
                },
                {
                    url: ROUTE_URLS.configs,

                    label: 'Configuration Templates',
                    enabled: checkPermissions(PERMISSIONS.admin_configs, currentUser?.permissions),
                },
                {
                    url: ROUTE_URLS.plugins,
                    label: 'Plugins',
                    enabled: checkPermissions(PERMISSIONS.admin_configs, currentUser?.permissions),
                },
                {
                    url: ROUTE_URLS.templates,
                    label: 'Templates',
                    enabled:
                        checkPermissions(PERMISSIONS.admin_configs, currentUser?.permissions) &&
                        (!currentUser?.company?.brand?.crm ||
                            currentUser?.company?.brand?.crm?.includes('v1')),
                },
                {
                    url: ROUTE_URLS.rego_templates,
                    label: 'Templates (New)',
                    enabled:
                        checkPermissions(PERMISSIONS.admin_configs, currentUser?.permissions) &&
                        (currentUser?.company?.brand?.rego_enabled ||
                            currentUser?.company?.brand?.crm?.includes('flow')),
                },
                {
                    url: ROUTE_URLS.constants,
                    label: 'Constants',
                    enabled: !currentUser?.company_id,
                },
            ],
        },
        {
            label: 'Collections',
            url: ROUTE_URLS.collections,
            enabled:
                checkPermissions(PERMISSIONS.admin, currentUser?.permissions) &&
                currentUser?.username === 'demo',
        },
    ];
};
